import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import connect from "react-redux/es/connect/connect";
import {newTireBrand} from "../../actions/tireActions";


function PneuFabricanteDialog({
                                  open,
                                  newTireBrand,
                                  onClose,
                                  value
                                }) {
   // const [value, setValue] = React.useState(value);
    //const [open, toggleOpen] = React.useState(dopen);



    const [dialogValue, setDialogValue] = React.useState({
        descricao: value.descricao,
        // year: '',
    });



    const handleClose = () => {
        setDialogValue({
            descricao: '',
        });
        onClose()
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        newTireBrand(dialogValue);
        handleClose();
    };

    //console.log("pneuFabricanteDialog open =>", open, dialogValue)

    return (
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <form onSubmit={handleSubmit}>
                    <DialogTitle id="form-dialog-title">Novo fabricante</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Nao existe o fabricante nesta lista? Adicione!
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            value={dialogValue.descricao}
                            onChange={(event) => setDialogValue({ ...dialogValue, descricao: event.target.value })}
                            label="Fabricante"
                            type="text"
                        />
                        {/*<TextField*/}
                        {/*    margin="dense"*/}
                        {/*id="name"*/}
                        {/*value={dialogValue.year}*/}
                        {/*onChange={(event) => setDialogValue({ ...dialogValue, year: event.target.value })}*/}
                        {/*label="year"*/}
                        {/*type="number"*/}
                        {/*/>*/}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancela
                        </Button>
                        <Button type="submit" color="primary">
                            Adiciona
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </React.Fragment>
    )

}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null,
        //PneuFabricantes: state.tires.fabricantes.data || [],

    }
}

export default connect(mapStateToProps, {
    newTireBrand
})(PneuFabricanteDialog)
